import React from 'react';
import { Select, Button } from 'antd';

import { FilterIcon } from '@components/icons';
import { Filter } from './hooks/useDevicesFilter';
import ContentFilter from '@components/snippets/ContentFilter';

const { Option, OptGroup } = Select;

function DevicesFilter({ t, filters, sort, onFilter, onSearch, onSort }) {
  return (
    <div className="devices-filter">
      <div className="devices-filter__left">
        <Select
          mode="multiple"
          value={filters}
          listHeight={420}
          suffixIcon={<FilterIcon className="devices-filter__select-icon" />}
          className="devices-filter__select"
          placeholder={t('device-filtering')}
          // onChange={onFilter}
          onSelect={onFilter}
          onDeselect={onFilter}
          dropdownClassName="devices-filter__dropdown"
        >
          <Option
            className="devices-filter__option devices-filter__option--reset"
            key={Filter.ANY_STATUS}
            value={Filter.ANY_STATUS}
          >
            <Button
              className="devices-filter__reset-btn"
              type="link"
              onClick={() => onFilter(Filter.ANY_STATUS)}
            >
              {t('any-device-status')}
            </Button>
          </Option>
          <OptGroup label={null}>
            <Option
              className="devices-filter__option"
              key={Filter.ONLINE}
              value={Filter.ONLINE}
            >
              {t('online')}
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.OFFLINE}
              value={Filter.OFFLINE}
            >
              {t('offline')}
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.IS_ACTIVATE}
              value={Filter.IS_ACTIVATE}
            >
              {t('not-activated')}
            </Option>
          </OptGroup>
          <Option
            className="devices-filter__option devices-filter__option--reset"
            key={Filter.ANY_OS}
            value={Filter.ANY_OS}
          >
            <Button
              className="devices-filter__reset-btn"
              type="link"
              onClick={() => onFilter(Filter.ANY_OS)}
            >
              {t('any-operating-system')}
            </Button>
          </Option>
          <OptGroup label={null}>
            <Option
              className="devices-filter__option"
              key={Filter.HUMMINGBOARD}
              value={Filter.HUMMINGBOARD}
            >
              Hummingboard
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.WINDOWS}
              value={Filter.WINDOWS}
            >
              Windows
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.SSSP}
              value={Filter.SSSP}
            >
              SSSP
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.ANDROID}
              value={Filter.ANDROID}
            >
              Android
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.TIZEN}
              value={Filter.TIZEN}
            >
              Tizen
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.WEBOS}
              value={Filter.WEBOS}
            >
              WebOS
            </Option>
          </OptGroup>
          <Option className="devices-filter__option devices-filter__option--reset">
            <Button
              className="devices-filter__reset-btn"
              type="link"
              onClick={() => onFilter([])}
            >
              {t('clear-all-filters')}
            </Button>
          </Option>
        </Select>
      </div>
      <ContentFilter
        sort={sort}
        onSearch={onSearch}
        onSort={onSort}
        className="devices-filter__right"
      />
    </div>
  );
}

export default DevicesFilter;
